import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  // "userDocument" association may be UserDocument or VisitorDocument
  userDocument: belongsTo({ polymorphic: true }),
});
